<template>
	<v-dialog
		v-model="show"
		@click:outside="closeDialog()"
		style="max-height: 100vh"
		max-width="1400"
		content-class="my-auto vh-80"
		@keyup.esc="closeDialog()"
		scrollable
	>
		<v-card v-if="image" class="wall-card">
				<v-card-text class="pa-0">
					<div class="bg-black sticky-top relative" style="overflow:hidden" :class="{'img-fullscreen': fullscreen}">
						<div class="image-actions ">
							<v-btn @click="pan = !pan" icon class="ml-auto"  ><v-icon :color="(pan ? 'accent' : 'white')">mdi-magnify</v-icon></v-btn>
							<v-btn :href="image.url_download" light icon color="white"><v-icon>$download</v-icon></v-btn>
							<v-btn @click="fullscreen = !fullscreen" light icon color="white">
								<v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
								<v-icon v-else>mdi-fullscreen</v-icon>
							</v-btn>
							<v-btn @click="closeDialog()" light icon color="white">
								<v-icon >mdi-close</v-icon>
							</v-btn>
						</div>
						<panZoom v-if="pan" :options="{minZoom: 0.5, maxZoom: 5}">
							<img :src="image.url" lazy-src="@/assets/images/image-placeholder.jpg" class="bg-black rounded image-preview">
						</panZoom>

						<v-img
							@click="pan = !pan"
							@scroll.native="pan = true"
							v-else
							contain
							:src="image.url"
							lazy-src="@/assets/images/image-placeholder.jpg"
							class="image-preview bg-black rounded zoom-in"
						/>
					</div>
				</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			dialogVisible: false,
			pan: false,
			fullscreen: false,
			image: null
		}
	},
	methods: {
		showDialog(image) {
			console.log("SHOULD SHOW DIALOG!", image)
			this.image = image;
			setTimeout(() => {
				this.show = true;
			}, 100)

		},
		closeDialog() {
			this.show = false;
			this.$emit('closed');
		}
	}
}
</script>
